import {
  PRE_GET_CREATOR_PROFILE,
  PRE_GET_CREATOR_DATA,
  CHANGE_PAGE,
  FILTER_PER_PAGE,
} from './constants';

export function loadCreatorProfile(params, api) {
  return {
    type: PRE_GET_CREATOR_PROFILE,
    payload: params,
    api,
  };
}

export function loadCreatorData(params, api) {
  return {
    type: PRE_GET_CREATOR_DATA,
    ...params,
    api,
  };
}

export function changePage(page) {
  return {
    type: CHANGE_PAGE,
    page,
  };
}

export function changePerPage(value) {
  return {
    type: FILTER_PER_PAGE,
    value,
  };
}
